import React from 'react'
import BaseInputText from './../Components/Common/TextInput'

const SectionTitleRow = ({ sectionIndex, touched, errors }) => {
  return (
    <div className='align-items-center title-row'>
      <BaseInputText
        name={`sections[${sectionIndex}].title`}
        placeholder='Section Title'
        label='Title'
      >
        {touched.sections?.[sectionIndex]?.title &&
          errors.sections?.[sectionIndex]?.title && (
            <div className='text-danger'>
              {errors.sections[sectionIndex].title}
            </div>
          )}
      </BaseInputText>
      <BaseInputText
        name={`sections[${sectionIndex}].description`}
        placeholder='Section Description'
        label='Description'
      >
        {touched.sections?.[sectionIndex]?.description &&
          errors.sections?.[sectionIndex]?.description && (
            <div className='text-danger'>
              {errors.sections[sectionIndex].description}
            </div>
          )}
      </BaseInputText>
    </div>
  )
}

export default SectionTitleRow
